import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { RouterLink } from "@angular/router";
import { AccessLevel, FormPageType, ProductDefinition } from "app/shared/model";
import { combineLatest, Observable } from "rxjs";
import { FormNavigationService } from "../form-navigation.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { fuseAnimations } from "@fuse/animations";
import { FormNavigationItem } from "../navigation.model";
import { isIterable } from "app/shared";

@Component({
    selector: 'iapply-page-menu',
    templateUrl: './page-menu.component.html',
    styleUrl: './page-menu.component.scss',
    animations: fuseAnimations,
    imports: [
        CommonModule,
        RouterLink,
    ]
})
export class PageMenuComponent
{
    private readonly _navigationService = inject(FormNavigationService);

    menuItems$: Observable<FormNavigationItem[]>
    currentMenuItem$: Observable<FormNavigationItem>;

    menuItems: FormNavigationItem[];
    allowForwardNavigation: boolean = false;
    AccessLevel = AccessLevel;
    currentPageIndex = 0;
    FormPageType = FormPageType;

    canNavigate = this._navigationService.canNavigate;

    constructor() {
        this.menuItems$ = this._navigationService.menuItems$
        this.currentMenuItem$ = this._navigationService._currentMenuItem;

        this._navigationService.product$
            .pipe(takeUntilDestroyed())
            .subscribe({
                next: (product: ProductDefinition) =>
                {
                    this.allowForwardNavigation = product?.allowForwardNavigation || false;
                }
            });

        combineLatest([
            this._navigationService.menuItems$,
            this._navigationService.currentMenuItem$,
        ])
            .pipe(takeUntilDestroyed())
            .subscribe({
                next: ([menuItems, currentMenuItem]) =>
                {
                    this.menuItems = menuItems;

                    if (!isIterable(menuItems) || currentMenuItem == null) {
                        return;
                    }

                    this.currentPageIndex = menuItems.findIndex(item => item.pageId === currentMenuItem.pageId);
                }
            });
    }


    isBack(item: FormNavigationItem): boolean
    {
        return false;
    }

    activeMenuItem(item: FormNavigationItem)
    {
        let currentItem = this._navigationService._currentMenuItem.value
        let pageIdMatch = currentItem?.pageId === item.pageId;
        let subPageIdMatch = item.controlId == null || currentItem?.controlId === item.controlId;
        return pageIdMatch && subPageIdMatch;
    }
}
